module.exports = __webpack_public_path__ + "img/banner2-2@1x.5d5f62df.jpg";